import { motion } from 'framer-motion';
import { fadeUp, staggerContainer, viewportOnce } from './Animations';
import accenture from '@/assets/accenture.png';
import capgemini from '@/assets/capgemini.png';
import deloitte from '@/assets/deloitte.png';
import ey from '@/assets/ey.png';
import jpmorgan from '@/assets/jpmorgan.png';
import microsoft from '@/assets/microsoft.png';
import pwc from '@/assets/pwc.png';
import { LogoMarquee } from './LogoMarquee';

/**
 * Placeholder employer-logo grid. The brochure's placements page (400+
 * companies) uses logo images that aren't machine-readable text, so this
 * renders empty, clearly-labeled slots for edept to drop real logos into.
 *
 * To add a real logo: replace the placeholder <div> for that slot with:
 *   <img src="/images/logos/company-name.png" alt="Company Name" className="mx-auto h-14 w-auto object-contain" />
 * and drop the file in public/images/logos/.
 */
const logos = [
  { src: accenture, alt: 'Accenture', className: 'max-h-10' },
  { src: capgemini, alt: 'Capgemini', className: 'max-h-10' },
  { src: deloitte, alt: 'Deloitte', className: 'max-h-7' },
  { src: ey, alt: 'EY', className: 'max-h-8' },
  { src: jpmorgan, alt: 'J.P. Morgan', className: 'max-h-6' },
  { src: microsoft, alt: 'Microsoft', className: 'max-h-7' },
  { src: pwc, alt: 'PwC', className: 'max-h-8' },
];
const LOGO_SLOT_COUNT = 12;

export default function CompanyLogos() {
  const slots = Array.from({ length: LOGO_SLOT_COUNT });

  return (
    <section className="px-6 pt-12 sm:px-10 lg:px-16">
      <div className="container-content">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={fadeUp}
          className="mx-auto max-w-2xl text-center"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-edept-orange">
            Hiring partners
          </p>
          <h2 className="mt-3 text-3xl text-edept-dark sm:text-4xl">Trusted by 400+ Companies</h2>
          <p className="mt-4 text-slate-600">
            Our graduates are building careers across technology, consulting, finance, and other high-growth sectors, with opportunities at 400+ companies around the world.
          </p>
        </motion.div>
        <div className='my-20'>
          <LogoMarquee />
          </div>


        {/* Example of a filled slot once a real logo is available \u2014 remove this comment block when logos are added:
        <img src="/images/logos/amazon.png" alt="Amazon" className="mx-auto h-14 w-auto object-contain" />
        */}
      </div>
    </section>
  );
}
